import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */
/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { h700 } from '@atlaskit/theme/typography';
var truncateStyles = css({
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var outerStyles = css({
  margin: "var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-200, 16px)", " 0")
});
var titleStyles = css({
  color: "var(--ds-text, #172B4D)",
  font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  letterSpacing: 'normal',
  marginBlockStart: 0,
  outline: 'none'
});
var styledTitleStyles = css({
  lineHeight: "var(--ds-font-lineHeight-500, 32px)",
  marginBlockStart: 0,
  outline: 'none'
});
var titleWrapperStyles = css({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap'
});
var titleWrapperTruncateStyles = css({
  flexWrap: 'nowrap'
});
var titleContainerStyles = css({
  minWidth: 0,
  maxWidth: '100%',
  flex: '1 0 auto',
  flexShrink: undefined,
  marginBlockEnd: "var(--ds-space-100, 8px)"
});
var actionStyles = css({
  maxWidth: '100%',
  flex: '0 0 auto',
  marginBlockEnd: "var(--ds-space-100, 8px)",
  marginInlineStart: 'auto',
  paddingInlineStart: "var(--ds-space-400, 32px)",
  whiteSpace: 'nowrap',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  '>': {
    textAlign: 'right'
  }
});
var titleContainerTruncateStyles = css({
  flexShrink: 1
});
var bottomBarStyles = xcss({
  marginBlockStart: 'space.200'
});

/**
 * __Outer wrapper__.
 *
 * An outer wrapper that is the outermost component of the PageHeader component. It wraps around the PageHeader, its Actions,
 * the BottomBar and its Breadcrumbs.
 *
 */
export var OuterWrapper = function OuterWrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: outerStyles
  }, children);
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var h700Styles = css(h700());
/**
 * __Styled title wrapper__.
 *
 * A styled title wrapper is a wrapper around the title that controls its the styles exclusively.
 *
 */
export var StyledTitleWrapper = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    id = _ref2.id,
    truncateTitle = _ref2.truncateTitle;
  return jsx("h1", {
    css: [].concat(_toConsumableArray(getBooleanFF('platform.design-system-team.page-header-tokenised-typography-styles_lj1ix') ? [titleStyles] : [h700Styles, styledTitleStyles]), [truncateTitle && truncateStyles]),
    ref: ref,
    tabIndex: -1,
    id: id
  }, children);
});
/**
 * __Title wrapper__.
 *
 * A title wrapper is a wrapper around the title and the actions.
 *
 */
export var TitleWrapper = function TitleWrapper(_ref3) {
  var children = _ref3.children,
    truncateTitle = _ref3.truncateTitle;
  return jsx("div", {
    css: [titleWrapperStyles, truncateTitle && titleWrapperTruncateStyles]
  }, children);
};

/**
 * Title container.
 *
 * A title container is a container that wraps around the title and its styles (if applied).
 *
 */
export var TitleContainer = function TitleContainer(_ref4) {
  var children = _ref4.children,
    truncateTitle = _ref4.truncateTitle;
  return jsx("div", {
    css: [titleContainerStyles, truncateTitle && titleContainerTruncateStyles]
  }, children);
};

/**
 * __Actions wrapper__.
 *
 * An actions wrapper is a wrapper for the actions, which appear on the top right of the PageHeader component.
 *
 */
export var ActionsWrapper = function ActionsWrapper(_ref5) {
  var children = _ref5.children;
  return jsx("div", {
    css: actionStyles
  }, children);
};

/**
 * __Bottom bar wrapper__.
 *
 * A bottom bar wrapper is a wrapper for the bottom bar, which appears at the bottom of the PageHeader component.
 *
 */
export var BottomBarWrapper = function BottomBarWrapper(_ref6) {
  var children = _ref6.children;
  return jsx(Box, {
    xcss: bottomBarStyles
  }, children);
};